import ufeApi from 'services/api/ufeApi';
import { gqlClient } from 'services/api/gql/gqlClient';
import { OrderHistory } from 'constants/gql/queries/profile/orderHistory.gql';
import { resolveLocaleEnum, normalizeOisOrder } from 'services/api/profile/getOrderHistory';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Order+History+API

/**
 * Fetches order history with full order details, routing to OIS GraphQL or OXS REST based on kill switch flags.
 * @param {string} userProfileId
 * @param {number} page
 * @param {number} limit
 * @returns {Promise<{numOrders: number, orders: Array}>}
 */
const getOrderHistoryWithDetails = async (userProfileId, page, limit) => {
    const globalEnabled = Sephora?.configurationSettings?.oisMigration?.global?.isEnabled;
    const orderHistoryEnabled = Sephora?.configurationSettings?.oisMigration?.orderHistory?.isEnabled;

    if (globalEnabled && orderHistoryEnabled) {
        const locale = resolveLocaleEnum(Sephora?.configurationSettings?.locale);

        const data = await gqlClient.query({
            operationName: 'OrderHistory',
            query: OrderHistory,
            variables: {
                input: {
                    clientId: userProfileId,
                    currentPage: page,
                    itemsPerPage: limit,
                    locale,
                    orderDetails: true
                }
            }
        });

        const result = data?.orderHistory;
        const oisOrders = result?.orders || [];

        // OIS does not return a total order count; infer whether more pages exist from page fullness
        const numOrders = oisOrders.length < limit
            ? (page - 1) * limit + oisOrders.length
            : page * limit + 1;

        return {
            numOrders,
            orders: oisOrders.map(normalizeOisOrder)
        };
    }

    const url = `/api/users/profiles/${userProfileId}/orders?currentPage=${page}&itemsPerPage=${limit}&orderDetails=true`;
    const data = await ufeApi.makeRequest(url, { method: 'GET' });

    if (data.errorCode) {
        throw data;
    }

    return {
        numOrders: data.orderCount,
        orders: data.orders
    };
};

export default getOrderHistoryWithDetails;
